export const StarIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M9.99887 15.216L4.121 18.5062L5.43377 11.8993L0.488281 7.32585L7.17748 6.53273L9.99887 0.416016L12.8202 6.53273L19.5094 7.32585L14.564 11.8993L15.8767 18.5062L9.99887 15.216Z"
        fill="#5DD4E8"
      />
    </svg>
  );
};
